import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card poppins" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9 pt-2" }
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-lg-4 fv-row content-left" }
const _hoisted_7 = { class: "row mb-3 image-border" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "row mb-3 image-mini-preview-container" }
const _hoisted_10 = ["onClick", "alt", "src"]
const _hoisted_11 = { class: "col-lg-5 fv-row" }
const _hoisted_12 = {
  class: "row mb-2 px-1",
  style: {"font-size":"20px","font-weight":"600"}
}
const _hoisted_13 = { class: "row mb-5 px-1 item-price" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2 px-1 item-description-title" }, "Tipe", -1)
const _hoisted_15 = { class: "row mb-2 px-1 item-description" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2 px-1 item-description-title" }, "Detail", -1)
const _hoisted_17 = { class: "col-lg-3 fv-row" }
const _hoisted_18 = { class: "card card-stretch shadow mb-5 card-px-1" }
const _hoisted_19 = { class: "row px-3" }
const _hoisted_20 = { class: "col-12 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Pilih Sekolah", -1)
const _hoisted_22 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-xs-12 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Jumlah", -1)
const _hoisted_26 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "col-xs-12 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Harga", -1)
const _hoisted_30 = { class: "item-price-total" }
const _hoisted_31 = { class: "col-12 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Catatan", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-to-cart me-3" }, "Update Keranjang")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-body px-1",
  style: {"padding-top":"10px !important","padding-bottom":"10px !important"}
}, null, -1)
const _hoisted_35 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  alt: "imageshow",
                  class: "img-fluid image-preview",
                  src: _ctx.detail.imageshow || ''
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.imgUrl, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: _normalizeClass(`col-2 image-border image-mini-preview ${
                  !item ? 'empty' : ''
                }`)
                  }, [
                    item
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.changeImage(item)),
                          alt: `img${index + 1}`,
                          class: "img-fluid",
                          src: item
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.detail.name), 1),
              _createElementVNode("div", _hoisted_13, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.detail.productData?.price)), 1),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.detail.productData?.type), 1),
              _hoisted_16,
              _createElementVNode("div", {
                class: _normalizeClass(`row mb-2 px-1 item-description ${
                _ctx.hideDescription ? 'hide-description' : ''
              }`),
                id: "description"
              }, _toDisplayString(_ctx.detail.productData?.description), 3)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_Multiselect, {
                      disabled: "",
                      modelValue: _ctx.target.idSekolah,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.target.idSekolah) = $event)),
                      placeholder: "Pilih Sekolah",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listSekolah,
                      searchable: true,
                      label: "name",
                      "track-by": "name",
                      "value-prop": "_id",
                      class: "multiselect-product"
                    }, null, 8, ["modelValue", "options"]),
                    (_ctx.target.idSekolah == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.errorsMessage.errorproductSekolah), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "jumlah",
                      class: "form-control form-control-lg",
                      placeholder: "Isi jumlah",
                      modelValue: _ctx.target.jumlah,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.target.jumlah) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.target.jumlah == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.errorsMessage.errorjumlah), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.target.jumlah * _ctx.detail.productData?.price)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("textarea", {
                      type: "text",
                      name: "catatan",
                      class: "form-control form-control-lg",
                      placeholder: "Isi catatan",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.target.catatan) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.target.catatan]
                    ])
                  ]),
                  _hoisted_33
                ]),
                _hoisted_34
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/superadmin/daftar-product')))
        }, " Kembali ")
      ])
    ])
  ], 64))
}